module.exports = __webpack_public_path__ + "static/images/icon-apple-new3.d2385d3.png";